import type { AllPricelistDoc } from '@erp/rpc';

type PricelistDocMeta = Pick<
  AllPricelistDoc,
  'caseNumber' | 'companyName' | 'createdAt'
>;

/** The present parts, joined the way both pricelist lists separate them. */
function joinParts(parts: (string | null)[]): string {
  return parts
    .filter((part): part is string => part !== null && part !== '')
    .join(' · ');
}

/**
 * Whose pricelist this is: its price-change case number (when the file is on a
 * case) and vendor. Empty for a file with neither. The case number leads
 * because it is what the lists can be searched by (`PC-12`), so a search by
 * number shows which rows matched on it.
 */
export function pricelistDocOwner(
  doc: Pick<PricelistDocMeta, 'caseNumber' | 'companyName'>,
): string {
  return joinParts([doc.caseNumber, doc.companyName]);
}

/** The line under a pricelist's name in the lists: owner, then upload date. */
export function pricelistDocSubtitle(doc: PricelistDocMeta): string {
  return joinParts([
    pricelistDocOwner(doc),
    doc.createdAt.toLocaleDateString(),
  ]);
}
